module.exports = __webpack_public_path__ + "img/_starmap3.8f77f10e.png";